import {Step} from './steps/step';
import {IntroStep} from './steps/intro.step';
import {EmailStep} from './steps/email.step';
import {Injectable, Type} from '@angular/core';
import {IntroComponent} from '../intro/intro.component';
import {BasicLoanInfoStep} from './steps/basic-loan-info.step';
import {PanVerificationStep} from './steps/pan-verification.step';
import {LoanInfoComponent} from '../loan-info/loan-info.component';
import {PhoneVerificationStep} from './steps/phone-verification.step';
import {AbstractApplicationFlowComponent} from './abstract-application-flow.component';
import {PhoneVerificationComponent} from '../phoneverification/phone-verification.component';
import {LoanApplicationPanVerificationComponent} from '../pan-verification/pan-verification.component';
import {LoanApplicationEmailVerificationComponent} from '../email-verification/email-verification.component';
import {LivelihoodInformationComponent} from '../livelihood-information/livelihood-information.component';
import {LivelihoodInformationStep} from './steps/livelihood-information.step';
import {PersonalInfoComponent} from '../personal-info/personal-info.component';
import {PersonalInformationStep} from './steps/personal-information.step';
import {BorrowedInfoComponent} from '../borrowed-info/borrowed-info.component';
import {BorrowedInfoStep} from './steps/borrowed-info.steps';
import {ResidenceProofStep} from './steps/residence-proof.step';
import {ResidenceProofComponent} from '../residence-proof/residence-proof.component';
import {BorrowerBankDetailsComponent} from '../borrower-bank-details/borrower-bank-details.component';
import {BankDetailStep} from './steps/bank-details.step';
import {UploadDocumentsStep} from './steps/upload-documents.step';
import {UploadDocumentsComponent} from '../upload-documents/upload-documents.component';
import {BorrowerSummaryComponent} from '../borrow/summary/borrower-summary.component';
import {BorrowerSummaryStep} from './steps/borrower-summary.step';

@Injectable()
export class LoanApplicationComponentStepMapper {
    private static readonly componentStepMapping: Map<Type<AbstractApplicationFlowComponent>, Type<Step>> =
        new Map<Type<AbstractApplicationFlowComponent>, Type<Step>>([
            [IntroComponent, IntroStep],
            [LoanInfoComponent, BasicLoanInfoStep],
            [LoanApplicationPanVerificationComponent, PanVerificationStep],
            [PhoneVerificationComponent, PhoneVerificationStep],
            [LoanApplicationEmailVerificationComponent, EmailStep],
            [PersonalInfoComponent, PersonalInformationStep],
            [LivelihoodInformationComponent, LivelihoodInformationStep],
            [BorrowedInfoComponent, BorrowedInfoStep],
            [ResidenceProofComponent, ResidenceProofStep],
            [BorrowerBankDetailsComponent, BankDetailStep],
            [UploadDocumentsComponent, UploadDocumentsStep],
            [BorrowerSummaryComponent, BorrowerSummaryStep]
        ]);

    public mapComponent(component: Type<AbstractApplicationFlowComponent>): Type<Step> {
        return LoanApplicationComponentStepMapper.componentStepMapping.get(component);
    }
}
